import * as React from 'react';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link';
  size?: 'default' | 'sm' | 'lg' | 'icon' | 'icon-sm';
  asChild?: boolean;
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className = '', variant = 'default', size = 'default', asChild = false, children, ...props }, ref) => {
    const variantClass = `shadcn-btn-${variant}`;
    const sizeClass = size === 'default' ? '' : `shadcn-btn-${size}`;
    const combined = ['shadcn-btn', variantClass, sizeClass, className].filter(Boolean).join(' ');

    if (asChild && React.isValidElement(children)) {
      const child = children as React.ReactElement<{ className?: string }>;
      return React.cloneElement(child, {
        className: [combined, child.props.className].filter(Boolean).join(' '),
      });
    }

    return (
      <button ref={ref} className={combined} {...props}>
        {children}
      </button>
    );
  }
);
Button.displayName = 'Button';
